import _ from "lodash";

// Currency formatter, USD (ex: $1,240.00). Returns null if NaN.
export function formatCurrency(value) {
  if (isNaN(value)) return null;
  const currencyFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  });
  return currencyFormatter.format(value);
}

/**
 * Returns a stringified number with ',' at thousands.
 * @param {number} value - number to format
 * @param {precision} precision - optional - decimal digits
 */
export function formatThousands(value, precision = 2) {
  if (isNaN(value)) return null;
  if (value < 1) return value.toString();
  const base = Math.floor(value)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const decimal = _.round(value - Math.floor(value), precision)
    .toString()
    .slice(1);
  return base + decimal;
}
